
















import { Vue, Component, Prop, Watch } from "@/shared/vuepack";
import { useUsStateStore } from "@/shared/store/usState";

@Component
export default class UsStateSelector extends Vue {
  usStateStore = useUsStateStore();

  @Prop()
  value: string;

  @Prop()
  isDisabled: boolean;

  @Prop()
  isInvalid: boolean;

  @Prop({ type: String, required: true })
  label: string;

  internalValue = "";

  mounted (): void {
    this.usStateStore.getStatesFromApi();
    this.internalValue = this.value || "";
  }

  @Watch("value")
  onValueChange () {
    if (this.value) {
      this.internalValue = this.value;
    } else {
      this.internalValue = "";
    }
  }

  updateValue (value) {
    this.$emit("input", value);
  }

  get statesList () {
    return this.usStateStore.getUsStates;
  }

  get isLoaded () {
    return this.usStateStore.isStatesLoaded;
  }
}
